import { Component, OnInit, Input, Inject } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { DialogOverviewExampleDialogComponent } from "../../dialog-overview-example-dialog/dialog-overview-example-dialog.component";
import { BackendApiService } from "../../../app/services/backend-api.service";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { ChangeUsersService } from "../../../app/services/change-users.service";
import { ConvertDatetimePipe } from "../../../app/convert-datetime.pipe";
import { CommonModule } from "@angular/common";
import { ChangeDetectorRef } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
//import {DOCUMENT} from '@angular/common';
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { MatIconModule } from "@angular/material/icon";
import { LeafletMapComponent } from "../leaflet-map/leaflet-map.component";
import { MatSlideToggle, MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatButtonModule } from "@angular/material/button";
@Component({
  selector: "app-admin-client-list",
  templateUrl: "./admin-client-list.component.html",
  styleUrls: ["./admin-client-list.component.scss"],
  standalone: true,
  imports: [CommonModule,MatMenuModule,MatIconModule,LeafletMapComponent,MatSlideToggle,NgxSpinnerModule, MatButtonModule,MatSlideToggleModule],
  providers:[NgxSpinnerService]
})
export class AdminClientListComponent implements OnInit {
  public imageBaseV2Url = BaseUrlConstantsService.NEW_IMAGE_RELATIVE_BASE_URL;
  public imageUploadUrl = BaseUrlConstantsService.IMAGE_UPLOAD;
  public imageBaseUrl = BaseUrlConstantsService.IMAGE_RELATIVE_URL + "uploads/";
  public deleteUserUrl = BaseUrlConstantsService.DELETE_USERS;
  public clientListingUrl = BaseUrlConstantsService.CLIENTS_LISTING;
  public assetsCountListUrl = BaseUrlConstantsService.Assets_Count;
  public subAssetsCountListUrl = BaseUrlConstantsService.Sub_Assets_Count;
  public pid: boolean =false;
  public showList: boolean =false;
  public emptyMsg: boolean =false;
  public checked = false;
  public clientList: any;
  public showSentMessage: boolean;
  public selectValueArr: any = [];
  public allClients: any = [];
  public showEmptyError: any = "";
  public classAdd: any;
  public today: Date = new Date;
  public selectedClientIDsArr: any = [];
  public clientIdList: any = [];
  public allAssets: any;
  public mergeAp: any = [];
  public assetscolor: any[] =[];
  public totalAssets: any;
  public asc:boolean=true;
  public timeasc:boolean=true;
  public clientIdListObj: any = [];
  public breadcrumbsArray: any = ["Clients"];
  public directionLogoHealthy: any = "down";
  public directionLogoUnsatisfactory: any = "leftright";
  public directionLogoUnacceptable: any = "up";
  public DSP = BaseUrlConstantsService.DSP_KEY;
  public onlyForDsp = this.DSP;
  public site_Maintenance: string = BaseUrlConstantsService.siteMaintenanceApi;
  public maintenanceLogList: any = [];
  public underMaintenance: any = false;
  public startHr = "";
  public endHr = "";
  public maintenance_day = "";
  public hideMarquee: boolean = false;
  public pubMarquee: boolean = false;
  public devicesSelected: boolean = true;
  public totalHealthyAssets: number = 0;
  public totalUnhealthyAssets: number = 0;
  public totalErrorAssets: number = 0;
  public totalOfflineAssets: number = 0;
  public totalAssetsCount: number = 0
  @Input() src: string ="";
  @Input() default: string="";
  assetsCounterSt: boolean = false;
  countryName: any;
  public showMap: boolean = false;

  constructor(
    private spinner: NgxSpinnerService,
    private changeService: ChangeUsersService,
    public router: Router,
    private service: BackendApiService,
    private activeRoute: ActivatedRoute,
    public dialog: MatDialog, // @Inject(Document)private documented: Document
    private cd: ChangeDetectorRef
  ) {
    this.showSentMessage = true;
    this.utcTime();
  }

  // getMaintenanceList() {
  //   this.service
  //     .getData(this.site_Maintenance + "/" + "maintenance")
  //     .then((res) => {
  //       let response = JSON.parse(JSON.stringify(res)).data;
  //       console.log(response, "res");
  //       if (response.status === "success") {
  //         if (response.body.length != 0) {
  //           this.showEmptyError = "";
  //           this.maintenanceLogList = response.body[response?.body?.length - 1];
  //           console.log(this.maintenanceLogList, "loglist");
  //           this.startHr = this.maintenanceLogList.start_date.slice(11, 16);
  //           this.endHr = this.maintenanceLogList.end_date.slice(11, 16);
  //           this.maintenance_day = this.maintenanceLogList.start_date.slice(
  //             0,
  //             10
  //           );
  //           //Hides marquee if today's date and start date of maintenance is same
  //           this.hideMarquee =
  //             new Date().getDate() ==
  //             new Date(this.maintenanceLogList.start_date).getDate();
  //           //Shows marquee if today's date and publish date of maintenance is same
  //           this.pubMarquee =
  //             new Date().getDate() ==
  //             new Date(this.maintenanceLogList.publish_date).getDate();
  //         } else {
  //           this.showEmptyError = "No maintenance log Available!";
  //         }
  //       } else {
  //         this.showEmptyError = "No maintenance log Available!";
  //       }
  //     });
  // }

  updateUrl(val: any) {}

  utcTime() {
    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }

  showDeleteDialog(id, index) {
    console.log(id);
    console.log(this.allAssets);
    console.log(this.clientList);
    let currentClient = this.allAssets.filter((asset) => asset.userId == id);
    let {
      errorAssetCount,
      healthyAssetCount,
      offlineAssetCount,
      unhealthyAssetCount,
    } = currentClient[0];
    if (
      errorAssetCount +
        healthyAssetCount +
        offlineAssetCount +
        unhealthyAssetCount >
      0
    ) {
      this.service.showError("Please delete all associated assets first");
      return;
    }

    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: "400px",
      height: "210px",
      data: {
        type: "delete-dialog-open",
        typeOf: "user",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        this.deleteUser(id, index);
        this.clientList = this.clientList.filter((client) => client.id != id);
        // this.mergeAp = this.clientList;
        this.mergeAp = this.clientList.map((obj, index) => ({
          ...obj,
          ...this.allAssets[index],
        }));
        console.log("Updated List");
        console.log(this.mergeAp);
      }
    });
  }

  seeUserAssets(userId, userName, vals) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        assetsFilterName: vals,
        admin_client_id: userId,
        clientName: userName,
        pageRef: "AdminClientPage",
      },
    };
    this.router.navigate(["/device-report-new"], navigationExtras);
  }

  deleteUser(user_id, index) {
    this.service.deleteInfo(this.deleteUserUrl + "/" + user_id).then((res) => {
      if (
        JSON.parse(JSON.stringify(res)).message.includes("successfully deleted")
      ) {
        this.classAdd = index;
        this.service.showSuccess("Successfully deleted.");
        this.allClients.splice(index, 1);
        if (this.allClients.length === 0) {
          this.showList = false;
          this.emptyMsg = true;
        }
      } else {
        this.service.showSuccess("Something went wrong.");
      }
    });
  }

  goToPageLink(name: string) {
    this.router.navigate([name]);
  }

  async selectListItem(event: any, index: number, id: number) {
    if (event.checked) {
      this.selectValueArr.push(id);
    } else {
      this.selectValueArr.splice(index, 1);
    }
    this.selectedClientIDsArr = Array.from(new Set(this.selectValueArr));
  }

  trackByFn(index, item) {
    return item.id;
  }

  ngOnInit() {
    this.getAllClients(this.onlyForDsp);
    // this.getMaintenanceList();
  }

  sentMessage(): void {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: "650px",
      data: {
        type: "viewSentmsg",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }
  viewAssetList(val: any, id, name) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        clientName: name,
        assetsFilterName: val,
        admin_client_id: id,
        pid: true,
        pageRef: "AdminClientPage",
      },
    };
    this.router.navigate(["/device-report-new"], navigationExtras);
  }

  // getAllClients() {

  //   this.service.getData(this.clientListingUrl + "CLIENT").then(async (res) => {
  //     console.log("1")
  //     if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
  //       console.log("2")
  //       this.clientList = JSON.parse(JSON.stringify(res)).data.body;
  //       console.log("3")
  //       //this.clientIdListObj=
  //       if (this.clientList.length !== 0) {
  //         this.showList = true;
  //         this.emptyMsg = false;
  //         this.changeService.loader(false);
  //         this.allClients= await this.clientList;
  //         console.log(this.allClients);
  //         this.clientIdList = this.allClients.map(ids => ids.id);
  //         this.clientIdListObj= {
  //           userIds:this.clientIdList
  //         }

  //         this.service.postData(this.assetsCountListUrl, this.clientIdListObj).then(async(res)=>{
  //           if (JSON.parse(JSON.stringify(res)).data.status === 'success'){

  //             this.allAssets=JSON.parse(JSON.stringify(res)).data.body;
  //             this.allAssets.clientsData.forEach(element => {
  //               var elementName = document.getElementById(element.userId)
  //               elementName.innerHTML = '<span dataText="Offline" type="button" routrLink="/device-report-new" id="span1" style="background:'+this.allAssets.healthStatusCode.OFFLINE+'">'+element.offlineAssetCount+'</span><img src="../../assets/arrow-'+element.avg_offline_status+'-solid1.png" width="30px" height="30px" style="margin-top:3px"><span dataText="Healthy" style="background:'+this.allAssets.healthStatusCode.HEALTHY+'">'+element.healthyAssetCount+'</span><img src="../../assets/arrow-'+element.avg_healthy_status+'-solid1.png" width="30px" height="30px" style="margin-top:3px"><span dataText="Unsatisfactory" style="background:'+this.allAssets.healthStatusCode.UNACCEPTABLE+'">'+element.unhealthyAssetCount+'</span><img src="../../assets/arrow-'+element.avg_unhealthy_status+'-solid1.png" width="30px" height="30px" style="margin-top:3px"><span dataText="Unacceptable" style="background:'+this.allAssets.healthStatusCode.ERROR+'">'+element.errorAssetCount+'</span><img src="../../assets/arrow-'+element.avg_error_status+'-solid1.png" width="30px" height="30px" style="margin-top:3px">';
  //             });
  //             document.getElementById("span1").addEventListener('click',function(){
  //                 window.location.href='device-reports-component.html';
  //             });
  //             this.assetscolor=JSON.parse(JSON.stringify(res)).data.body.healthStatusCode;
  //           }
  //         });
  //       } else {
  //         this.showList = false;
  //         this.emptyMsg = true;
  //       }
  //     } else {
  //       this.changeService.loader(false);
  //       this.showList = false;
  //       this.emptyMsg = true;
  //       this.service.showError('Something went wrong.');
  //     }
  //   }, err => {
  //     this.changeService.loader(false);
  //   });
  // }
 private calculateTotals(assetsData: any[]) {
  console.log(assetsData,'assetdata')
    if (assetsData && assetsData.length > 0) {
      this.totalHealthyAssets = assetsData.reduce((acc, curr) => acc + (curr.healthyAssetCount || 0), 0);
      this.totalUnhealthyAssets = assetsData.reduce((acc, curr) => acc + (curr.unhealthyAssetCount || 0), 0);
      this.totalErrorAssets = assetsData.reduce((acc, curr) => acc + (curr.errorAssetCount || 0), 0);
      this.totalOfflineAssets = assetsData.reduce((acc, curr) => acc + (curr.offlineAssetCount || 0), 0);
      this.totalAssetsCount = this.totalHealthyAssets + this.totalUnhealthyAssets + this.totalErrorAssets + this.totalOfflineAssets;
    } else {
      this.totalHealthyAssets = 0;
      this.totalUnhealthyAssets = 0;
      this.totalErrorAssets = 0;
      this.totalOfflineAssets = 0;
      this.totalAssetsCount = 0;
    }
    console.log("Total Healthy Assets: ", this.totalHealthyAssets);
    console.log("Total Unhealthy Assets: ", this.totalUnhealthyAssets);
    console.log("Total Error Assets: ", this.totalErrorAssets);
    console.log("Total Offline Assets: ", this.totalOfflineAssets);
    console.log("Total Assets Count: ", this.totalAssetsCount);
  }
  //merge to api
  getAllClients(e) {
    if (e.checked == false && this.DSP) this.onlyForDsp = false;
    if (e.checked || this.onlyForDsp) {
      this.devicesSelected = false;
      this.cd.detectChanges();
      this.spinner.show();
      this.service.getData(this.clientListingUrl + "CLIENT").then(
        async (res) => {
          if (JSON.parse(JSON.stringify(res)).data.status === "success") {
            this.clientList = JSON.parse(JSON.stringify(res)).data.body;
            //this.clientIdListObj=
            if (this.clientList.length !== 0) {
              this.showList = true;
              this.emptyMsg = false;
              this.changeService.loader(false);
              this.allClients = await this.clientList;
              this.clientIdList = this.allClients.map((ids) => ids.id);
              console.log(typeof this.clientIdList[0]);
              this.clientIdList = this.clientIdList.map((index, key) => {
                return parseInt(
                  Math.floor(Math.random() * 90 + 10) +
                    index.toString() +
                    Math.floor(Math.random() * 9000 + 1000)
                );
              });
              this.clientIdListObj = {
                userIds: this.clientIdList,
              };

              // console.log(  this.clientIdListObj,'dsfsfs')
              this.service
                .postData(this.subAssetsCountListUrl, this.clientIdListObj)
                .then(async (res) => {
                       let clientAssets = JSON.parse(JSON.stringify(res)).data.body;
                  this.calculateTotals(clientAssets);
                  this.spinner.hide();
                  console.log(res, "ressssssss");
                  if (JSON.parse(JSON.stringify(res)).data.code.length == 500) {
                    console.log("enerterinss");
                    this.mergeAp = this.clientList;
                    this.assetsCounterSt = false;
                    this.spinner.hide();
                  } else {
                    this.assetsCounterSt = true;
                    this.allAssets = JSON.parse(JSON.stringify(res)).data.body;
                    this.mergeAp = this.allClients.map((obj, index) => ({
                      ...obj,
                      ...this.allAssets[index],
                    }));
                    console.log(this.mergeAp, "mergeApppppp");
                    this.assetscolor = JSON.parse(
                      JSON.stringify(res)
                    ).data.healthStatusCode;
                    console.log(this.assetscolor, "color");
                    this.spinner.hide();
                  }
                  // }, (err) => {
                  //   console.log(err,'reerrr')
                  //   this.spinner.hide();
                  //   this.changeService.loader(false);
                });
            } else {
              this.showList = false;
              this.emptyMsg = true;
              this.spinner.hide();
            }
          } else {
            this.changeService.loader(false);
            this.showList = false;
            this.emptyMsg = true;
            this.spinner.hide();
            this.service.showError("Something went wrong.");
          }
        },
        (err) => {
          this.changeService.loader(false);
        }
      );
    } else {
      this.devicesSelected = false;
       this.cd.detectChanges();
      this.spinner.show();
      this.service.getData(this.clientListingUrl + "CLIENT").then(
        async (res :any) => {

          if (JSON.parse(JSON.stringify(res)).data.status === "success") {
            this.clientList = JSON.parse(JSON.stringify(res)).data.body;
            //this.clientIdListObj=
            if (this.clientList.length !== 0) {
              this.showList = true;
              this.emptyMsg = false;
              this.changeService.loader(false);
              this.allClients = await this.clientList;
              this.clientIdList = this.allClients.map((ids) => ids.id);
              this.clientIdListObj = {
                userIds: this.clientIdList,
              };

              this.service
                .postData(this.assetsCountListUrl, this.clientIdListObj)
                .then(async (res) => {
                   let clientAssets = JSON.parse(JSON.stringify(res)).data.body.clientsData;
                    console.log(clientAssets)
                  this.calculateTotals(clientAssets);

                  if (
                    JSON.parse(JSON.stringify(res)).code == "ER_NO_SUCH_TABLE"
                  ) {
                    this.mergeAp = this.clientList;
                    this.assetsCounterSt = false;
                  } else {
                    this.assetsCounterSt = true;
                    this.allAssets = JSON.parse(
                      JSON.stringify(res)
                    ).data.body.clientsData;
                    this.mergeAp = this.allClients.map((obj, index) => ({
                      ...obj,
                      ...this.allAssets[index],
                    }));
                    this.assetscolor = JSON.parse(
                      JSON.stringify(res)
                    ).data.body.healthStatusCode;
                    this.spinner.hide();
                    console.log(this.mergeAp)
                  }
                });
            } else {
              this.showList = false;
              this.emptyMsg = true;
              this.spinner.hide();
            }
          } else {
            this.changeService.loader(false);
            this.showList = false;
            this.emptyMsg = true;
            this.spinner.hide();
            this.service.showError("Something went wrong.");
          }
        },
        (err) => {
          this.changeService.loader(false);
        }
      );
    }
  }

  //for mergeAp serchData
  searchData(ev) {
    if (this.allAssets != undefined) {
      this.allClients = this.clientList.map((obj, index) => ({
        ...obj,
        ...this.allAssets[index],
      }));
      const term = ev.toLowerCase();

      this.mergeAp = this.allClients.filter(
        (tag) =>
          tag.company_name.toLowerCase().indexOf(term) >= 0 ||
          tag.country.toLowerCase().indexOf(term) >= 0 ||
          tag.industry_type.toLowerCase().indexOf(term) >= 0
      );
    } else {
      const term = ev.toLowerCase();
      this.mergeAp = this.allClients.filter(
        (tag) =>
          tag.company_name.toLowerCase().indexOf(term) >= 0 ||
          tag.country.toLowerCase().indexOf(term) >= 0 ||
          tag.industry_type.toLowerCase().indexOf(term) >= 0
      );
    }
  }

  //end mergeAp serchData
  // searchData(ev) {
  //   const term = ev.toLowerCase();
  //   this.allClients = this.clientList.filter(tag => tag.company_name.toLowerCase().indexOf(term) >= 0 || tag.country.toLowerCase().indexOf(term) >= 0 || tag.industry_type.toLowerCase().indexOf(term) >= 0);
  //   this.clientIdListObj= {
  //     userIds:this.clientIdList
  //   }

  //   this.service.postData(this.assetsCountListUrl, this.clientIdListObj).then(async(res)=>{
  //     if (JSON.parse(JSON.stringify(res)).data.status === 'success'){
  //       this.allAssets=JSON.parse(JSON.stringify(res)).data.body;
  //       this.allAssets.clientsData.forEach(element => {
  //         var elementName = document.getElementById(element.userId)
  //         if(elementName!=null)
  //         elementName.innerHTML = '<span dataText="Offline" id="span1" style="background:'+this.allAssets.healthStatusCode.OFFLINE+'">'+element.offlineAssetCount+'</span><img src="../../assets/arrow-'+element.avg_offline_status+'-solid1.png" width="30px" height="30px" style="margin-top:3px"><span dataText="Healthy" style="background:'+this.allAssets.healthStatusCode.HEALTHY+'">'+element.healthyAssetCount+'</span><img src="../../assets/arrow-'+element.avg_healthy_status+'-solid1.png" width="30px" height="30px" style="margin-top:3px"><span dataText="Unsatisfactory" style="background:'+this.allAssets.healthStatusCode.UNACCEPTABLE+'">'+element.unhealthyAssetCount+'</span><img src="../../assets/arrow-'+element.avg_unhealthy_status+'-solid1.png" width="30px" height="30px" style="margin-top:3px"><span dataText="Unacceptable" style="background:'+this.allAssets.healthStatusCode.ERROR+'">'+element.errorAssetCount+'</span><img src="../../assets/arrow-'+element.avg_error_status+'-solid1.png" width="30px" height="30px" style="margin-top:3px">';
  //       });
  //       //document.getElementById("span1").addEventListener('click',(function());
  //       //this.assetscolor=JSON.parse(JSON.stringify(res)).data.body.healthStatusCode;
  //     }
  //   });
  //   //   console.log(this.allClients)
  //   //  this.mergeAp=this.allClients.map((obj,index)=>({
  //   //           ...obj,
  //   //           ...this.allAssets[index],
  //   //  }));
  //   //  console.log(this.mergeAp)
  //   //  this.mergeAp.forEach(element => {
  //   //   var elementName = document.getElementById(element.userId)
  //   //   elementName.innerHTML = '<span dataText="Offline" style="background:'+this.allAssets.healthStatusCode.OFFLINE+'">'+element.offlineAssetCount+'</span><span dataText="Healthy" style="background:'+this.allAssets.healthStatusCode.HEALTHY+'">'+element.healthyAssetCount+'</span><span dataText="Unsatisfactory" style="background:'+this.allAssets.healthStatusCode.UNACCEPTABLE+'">'+element.errorAssetCount+'</span><span dataText="Unacceptable" style="background:'+this.allAssets.healthStatusCode.ERROR+'">'+element.unhealthyAssetCount+'</span>';
  //   // });
  //   //let filterAssets=this.allAssets.clientsData.filter(tag =>tag.userId==this.allClients);

  //   if (this.allClients.length === 0) {
  //     this.showEmptyError = 'Not found!';
  //   } else {
  //     this.showEmptyError = '';
  //   }
  // }

  async addClients() {
    this.router.navigate(["/add-client"]);
  }

  async editClient(id) {
    this.countryName = this.mergeAp.filter((tag) => tag.id == id);
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        adminClientId: id,
        pid: true,
        countryname: this.countryName[0].country,
        pageRef: "admin-client",
      },
    };
    this.router.navigate(["/add-client"], navigationExtras);
  }

  async showLicense() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: "650px",
      data: {
        type: "adminLicense",
      },
    });
  }
  showMapFunction(val) {
    this.showMap = val;
  }
  sortByEvent(event){
    if (event === 'name') {
      if (this.asc) {
        this.mergeAp = this.mergeAp.sort((a, b) =>
          a.company_name.replaceAll(' ', '').toLowerCase()
            .localeCompare(b.company_name.replaceAll(' ', '').toLowerCase())
        );
      } else{
        this.mergeAp = this.mergeAp.sort((a, b) =>
          b.company_name.replaceAll(' ', '').toLowerCase()
            .localeCompare(a.company_name.replaceAll(' ', '').toLowerCase())
        );
      }
     this.asc=!this.asc;
    }
   else{
       if (this.timeasc) {
        this.mergeAp = this.mergeAp.sort((a, b) =>
          new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
        );
      } else{
        this.mergeAp = this.mergeAp.sort((a, b) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
        );
      }
      this.timeasc=!this.timeasc
    }
  }
}
